<template>
    <Teleport to="body">
        <div class="modal" tabindex="-1" id="confirmation" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1>{{ $trans.get('__JSON__.Vacation changed - need approval') }}!</h1>
                    </div>
                    <div class="modal-body">                    
                        <div v-if="Object.keys(localVacationRequests).length > 0">
                            <div >
                                <div class="card-body">
                                    <table class="table table-striped w-100">                                        
                                        <tbody>
                                            <template v-for="(requests, requestKey) in localVacationRequests" :key="requestKey">
                                                <template v-for="(request, index) in requests" :key="index">
                                                    <tr v-if="request.needs_confirmation">
                                                        <td v-if="request.message">
                                                            {{ request.message }}
                                                        </td>
                                                        <td class="text-end">
                                                            <button class="btn btn-primary" @click="saveRequest(request)">
                                                                Bestätigen
                                                            </button>
                                                        </td>
                                                    </tr>  
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>                             
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">                        
                        <span class="text-danger">{{ $trans.get("__JSON__.If you don't agree with these changes please contact your superior.") }}</span>    
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import {formatDateView} from "../formatdate";

export default {
    name: 'VacationConfirmation',
    props: {
        vacationRequests: {
            type: Object,
            required: true,
        },
        employee: null,
    },
    data() {
        return {
            errors: null,
            localVacationRequests: {},
            vacationMessages: []
        }
    },
    mounted() {
        this.localVacationRequests = { ...this.vacationRequests };
        this.displayChange();
        $('#confirmation').modal('show');        
    },
    methods: {
        formatDateView,
        saveRequest(request) {
            if (request) { 
                axios
                    .put(`/api/vacationrequests/${request.id}/confirm`, request)
                    .then(() => {
                        // Find the specific request in the array and set needs_confirmation to 0
                        if (this.localVacationRequests[request.absence_id]) {
                            const index = this.localVacationRequests[request.absence_id].findIndex(vacationRequest => vacationRequest.id === request.id);
                            if (index !== -1) {
                                this.localVacationRequests[request.absence_id][index].needs_confirmation = 0;
                            }
                        }
                        
                        // Check if there are any remaining requests that need confirmation
                        const hasRemainingConfirmations = Object.values(this.localVacationRequests).some(requests => 
                            requests.some(vacationRequest => vacationRequest.needs_confirmation === 1)
                        );
                        
                        if (!hasRemainingConfirmations) {
                            $('#confirmation').modal('hide');
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.errors = error.response.data.errors;
                    });
            } else {
                console.log("Request to update not found", request.id);
            }
        },
        displayChange() {
            Object.entries(this.localVacationRequests).forEach(([key, requests]) => {
                requests.forEach((request, index) => {
                    if (!request.needs_confirmation) {
                        return;
                    }

                    const nextRequest = requests[index + 1];
                    let message = this.$trans.get('__JSON__.The vacation from') + ' ';

                    if(request.declined) {
                        message += formatDateView(request.start_at) + ' ' +
                                   this.$trans.get('__JSON__.to') + ' ' + formatDateView(request.end_at) + ' ' +
                                   this.$trans.get('__JSON__.was declined by') + ' ' + request.user.name;
                    } else if (request.changed) {
                        // use old start and end date if it changed
                        const originalStartDate = !request.changed.start_at ? request.start_at : 
                                                nextRequest ? nextRequest.start_at : request.start_at;
                        
                        const originalEndDate = !('end_at' in request.changed) ? request.end_at :
                                                nextRequest ? nextRequest.end_at : request.end_at;
                        
                        const newStartDate = request.changed.start_at || request.start_at;
                        const newEndDate = request.changed.end_at || request.end_at;
                        
                        // Build message with original dates
                        message += formatDateView(originalStartDate) + ' ' + this.$trans.get('__JSON__.to') + ' ' + formatDateView(originalEndDate) + ' ';

                        message += this.$trans.get('__JSON__.was changed by') + ' ' + request.user.name + ' ' + this.$trans.get('__JSON__.changed to') + ' ';

                        const changes = [];
                        
                        // Date changes
                        if(newStartDate !== originalStartDate || newEndDate !== originalEndDate) {
                            changes.push(this.$trans.get('__JSON__.the :startAt to :endAt', {
                                startAt: formatDateView(newStartDate), 
                                endAt: formatDateView(newEndDate)
                            }));
                        }             
                        
                        if(request.changed.special_leave) {
                            changes.push(this.$trans.get('__JSON__.special leave'));
                        } else if(request.changed.special_leave === 0) {
                            changes.push(this.$trans.get('__JSON__.no special leave'));
                        }

                        if(request.changed.half_day) {
                            changes.push(this.$trans.get('__JSON__.a half day'));
                        } else if(request.changed.half_day === 0) {
                            changes.push(this.$trans.get('__JSON__.a full day'));
                        }

                        if(request.changed.unpaid) {
                            changes.push(this.$trans.get('__JSON__.unpaid'));
                        } else if(request.changed.unpaid === 0) {
                            changes.push(this.$trans.get('__JSON__.paid'));
                        }                        
                        
                        // Add all changes with "and" between
                        if (changes.length > 0) {
                            changes.forEach((change, i) => {
                                if (i > 0) {
                                    message += ' ' + this.$trans.get('__JSON__.and') + ' ';
                                }
                                message += change;
                            });
                        } 
                    } else {
                        // New vacation request
                        message += formatDateView(request.start_at);
                        
                        if (request.start_at !== request.end_at) {
                            message += ' ' + this.$trans.get('__JSON__.to') + ' ' + formatDateView(request.end_at);
                        }
                        
                        message += ' ' + this.$trans.get('__JSON__.was created by') + ' ' + request.creator.name;
                    }
                    
                    // Add comment if available
                    if (request.comment) {
                        message += ' ' + this.$trans.get("__JSON__.with the comment:") + ' ' + request.comment;
                    } else {
                        message += '.';
                    }
                    
                    request.message = message;
                });
            });
        }
    },        
}
</script>

<style scoped>

.material-symbols-outlined {
  font-variation-settings:
  'wght' 600,
  'opsz' 24
}

</style>